import __request__ from "routing/request";
export function listContentPacks(requestOptions) {
  return __request__("GET", "/system/content_packs", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function createContentPack(Requestbody, requestOptions) {
  return __request__("POST", "/system/content_packs", Requestbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listLatestContentPacks(requestOptions) {
  return __request__("GET", "/system/content_packs/latest", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listContentPackRevisions(contentPackId, requestOptions) {
  return __request__("GET", `/system/content_packs/${contentPackId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteContentPack(contentPackId, requestOptions) {
  return __request__("DELETE", `/system/content_packs/${contentPackId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listContentPackInstallationsById(contentPackId, requestOptions) {
  return __request__("GET", `/system/content_packs/${contentPackId}/installations`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteContentPackInstallationById(contentPackId, installationId, requestOptions) {
  return __request__("DELETE", `/system/content_packs/${contentPackId}/installations/${installationId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function uninstallDetails(contentPackId, installationId, requestOptions) {
  return __request__("GET", `/system/content_packs/${contentPackId}/installations/${installationId}/uninstall_details`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getContentPackRevisions(contentPackId, revision, requestOptions) {
  return __request__("GET", `/system/content_packs/${contentPackId}/${revision}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteContentPackBycontentPackIdAndrevision(contentPackId, revision, requestOptions) {
  return __request__("DELETE", `/system/content_packs/${contentPackId}/${revision}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function downloadContentPackRevisions(contentPackId, revision, requestOptions) {
  return __request__("GET", `/system/content_packs/${contentPackId}/${revision}/download`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function installContentPack(contentPackId, revision, installationrequest, requestOptions) {
  return __request__("POST", `/system/content_packs/${contentPackId}/${revision}/installations`, installationrequest, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
